"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class RegExValidator {
    constructor(pattern, modifiers) {
        this.pattern = pattern;
        this.modifiers = modifiers;
    }
    isValid(input) {
        if (typeof input === "undefined" || input === null) {
            return false;
        }
        return validatorJS.matches(input, this.pattern, this.modifiers);
    }
}
exports.RegExValidator = RegExValidator;
//# sourceMappingURL=RegExValidator.js.map